// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogList_container__6561J","blogRow":"BlogList_blogRow__OPao8"};